import merge from 'lodash/merge'
import { parseResponsiveProperty } from '@converdy/styles'

export default function baseButtonStyles({
  color,
  background,
  size,
}) {
  
  let jss = {
    '&': {
      '--iconColor': color, 
      '--bg': background, 
      ...parseResponsiveProperty('--size', size)
    }
  }

  return jss
}
